import React from 'react';
import {Button, Form} from 'antd';
// import "./Login.css";
import {useController} from "./Login.controller";
import loginValidation from "./loginValidation";
import FormInput from "../../components/FormInput/FormInput";
import DataType from "../../constants/DataType";
import UserOutlined from "@ant-design/icons/es/icons/UserOutlined";
import LockOutlined from "@ant-design/icons/es/icons/LockOutlined";
import StyledContainer from "./Login.style";
import loginLogo from "./assets/planetsoft-login.png";
import loginLogoDarkMode from "./assets/planetsoft-login-dark-mode.png";

const layout = {
    labelCol: {span: 8},
    wrapperCol: {span: 16},
};

const Login = ({loginLogoStyle}) => {
    const {login, loginInProgress, darkMode} = useController();

    document.getElementsByTagName('body')[0].style.background = darkMode ? 'black' : 'white'; // hardcoded

    return (
        <StyledContainer darkMode={darkMode}>
            {
                darkMode ?
                    <img src={loginLogoDarkMode} alt="logo" className="login-logo" style={loginLogoStyle}/> :
                    <img src={loginLogo} alt="logo" className="login-logo" style={loginLogoStyle}/>
            }
            <Form onFinish={login} {...layout} className="login-form">

                <FormInput readOnly={loginInProgress} label='Username' name='username' icon={<UserOutlined/>}
                           rules={loginValidation.username}/>

                <FormInput readOnly={loginInProgress} label='Password' name='password' icon={<LockOutlined/>}
                           rules={loginValidation.password}
                           type={DataType.PASSWORD}/>

                <Form.Item className='login-button-form-item'>
                    <Button
                        block
                        loading={loginInProgress}
                        type="primary"
                        htmlType="submit"
                        className="login-form-button"
                    >
                        Login
                    </Button>
                </Form.Item>
            </Form>
        </StyledContainer>);
};

export default Login;